import GameState from "slotworks/model/game-state";
import FreespinRecord from "integration/revolver/schema/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class LoopWinsDecision extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        let loopWins = true;
        if(record.freespinsTriggered) {
            loopWins = false;
        }

        return loopWins ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/decisions/loop-wins-decision.ts